import { useAgent } from "../providers/AgentProvider";
import { useError } from "../providers/ErrorProvider";
import { useWidget } from "../providers/WidgetProvider";
import {Play} from "lucide-react"
import ErrorToast from "./ErrorToast";

export default function ErrorScreen() {
  const { agentData } = useAgent();
  const { errorMsg, resetErrors } = useError();
  const { resetDailyState } = useWidget();

  const imgUrl = agentData?.image_url;

  const handlePlayClick = () => {
    resetDailyState();
    resetErrors();
  };

  return (
    <div className="fixed inset-0 w-full h-full flex flex-col items-center justify-center">
      {/* Dark underlay */}
      <div className="absolute w-full h-full bg-black" />
      
      {/* Blurred background image */}
      {imgUrl && (
        <div 
          className="absolute w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url(${imgUrl})`,
            filter: 'blur(25px) brightness(0.5)',
          }}
        />
      )}
      
      {/* Error message banner */}
      <ErrorToast errorMsg={errorMsg} />

      {/* Play button - centered */}
      <button
        onClick={handlePlayClick}
        className="absolute flex items-center justify-center"
        aria-label="Play video"
      >
        <span className="opacity-100 hover:opacity-80 transition-opacity cursor-pointer">
          <Play size={40} fill="white" color="none"></Play>
        </span>
      </button>
    </div>
  );
}

